import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSliderModule } from 'ngx-slider-v2';
import { CustomCurrencyPipe } from '../../pipes/custom-currency/custom-currency.pipe';
import { InputNumberModule } from '../input-number/input-number.module';
import { RangeSliderComponent } from './range-slider.component';

@NgModule({
  declarations: [RangeSliderComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, NgxSliderModule, InputNumberModule, CustomCurrencyPipe],
  exports: [RangeSliderComponent],
})
export class RxRangeSliderModule {}
